import CommunicationHandler, { IEvent } from '@mirage-projects/communication-library';
import { ProcessData, ParamObj, GlobalData, MockData, StepEventData } from '@mirage-projects/cw-models';

import { logService } from './Log';
import { Step } from './Step';

export class Process implements ProcessData {
    name: string;
    steps: Step[] = [];

    constructor(name: string, ...stepList: Step[]) {
        this.name = name;

        this.addSteps(stepList);
    }

    /**
     * Runs the process
     * @param communicationHandler Handles the communication events
     * @param params params to override default values
     * @param globalData global data to be accessed by the process
     * @param prevData info to debugging this function
     * @returns a promise with the execution result
     */
    async run(
        communicationHandler: CommunicationHandler,
        params: ParamObj,
        globalData?: GlobalData,
        prevData?: GlobalData
    ): Promise<MockData[]> {
        const prevDataArray = prevData ? [prevData] : [];

        try {
            const resultData = await this.steps.reduce<Promise<(StepEventData | IEvent)[]>>(async (acc, step) => {
                const accumulatedResults = await acc;
                const result = await step.run(communicationHandler, params, globalData, prevData, { process: this });
                return result ? [...accumulatedResults, result] : [...accumulatedResults];
            }, Promise.resolve([]));

            return [...prevDataArray, ...resultData];
        } catch (e) {
            logService.warn('Was not possible to run step', e);
            return [...prevDataArray];
        }
    }

    private addSteps(stepList: Step[]): void {
        this.steps = this.steps.concat(stepList.map((step) => step.clone()));
    }
}
